import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mx-auto w-full flex flex-col bg-brand-dark-gray rounded-xl px-4 py-3.5 pt-3 pr-2 font-medium text-lg text-white transition-all" }
const _hoisted_2 = { class: "flex flex-col m-auto w-full pt-0.5" }
const _hoisted_3 = {
  key: 0,
  class: "uppercase text-left w-full text-xs text-brand-light-gray"
}
const _hoisted_4 = { class: "flex w-full justify-between my-auto" }
const _hoisted_5 = { class: "flex space-x-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "my-auto",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10 16.5L14 12L10 7.5",
    stroke: "white",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_7 = {
  key: 0,
  class: "flex flex-wrap"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuButton',
  props: {
  name: {
    type: String,
    required: true
  },
  inlineLabel: {
    type: String,
    required: false
  }
},
  setup(__props) {


const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.inlineLabel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.inlineLabel), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "start"),
          _createElementVNode("div", null, _toDisplayString(__props.name), 1)
        ]),
        _renderSlot(_ctx.$slots, "end", {}, () => [
          _hoisted_6
        ])
      ])
    ]),
    (_ctx.$slots.bottom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "bottom")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})